import { render, staticRenderFns } from "./PerformanceIndicatorsSet.vue?vue&type=template&id=0724c70c&"
import script from "./PerformanceIndicatorsSet.vue?vue&type=script&lang=js&"
export * from "./PerformanceIndicatorsSet.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceIndicatorsSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports